import Vue from 'vue'
import Vuex from 'vuex'
import axios from '@/api/index'

import Nprogress from 'nprogress';
import globalAxios from 'axios'

import router from '@/router/index'
import qs from 'qs'
import moment from "moment";
Vue.use(Vuex)

const state = {
    allAccountDetailsData: [],
    rechargeChargedData: [],
    paymentChargedData: [],
    paymentIndexData: []
}
const mutations = {
    SET_ACCOUNT_DETAILS(state, data) {
        state.allAccountDetailsData = data
    },
    SET_RECHARGE_DATA(state, data) {
        state.rechargeChargedData = data
    },
    SET_PAYMENT_DATA(state, data) {
        state.paymentChargedData = data;
    },
    SET_PAYMENTINDEX_DATA(state, data) {
        state.paymentIndexData = data;
    }
}
const actions = {

    fetchAccountBillingsData({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            axios.post('/payment/billing_detail_data', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    commit("SET_ACCOUNT_DETAILS", response.data.response)
                    console.log("response for all", response.data.response);

                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    companyFieldNameSave({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            axios.post('/payment/edit_billing_details', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    companyFieldNameDelete({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            axios.post('/payment/delete_billing_details_list/' + postData.id + "/" + true)
                .then(response => {
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    importAccountBillingDetails({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/payment/import_billing_details_file', postData)
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    accountUnblocklist({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/payment/accountUnblock_list/' + postData.id + "/" + postData.status)
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    getAllCreateNewAccountDatas({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.get('/payment/add_account_billing_details_list')
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    submitAccountBillingDetails({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/payment/submit_account_billing_details.json', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    rechargeChangeFetch({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            axios.post('/payment/recentCharges_data_list', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    commit("SET_RECHARGE_DATA", response.data)
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    paymentChangeFetch({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            axios.post('/payment/paymentLog_data_list', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    commit("SET_PAYMENT_DATA", response.data)
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    fetchpaymentlistData({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            axios.post('/payment/payment_index_list', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    commit("SET_PAYMENTINDEX_DATA", response.data)
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    payNowPayment({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/payment/pay_now_link', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    updatePaymentDetailDataPage({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/payment/update_company_details', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
}
const getters = {
    allAccountDetailsDataListGetters: state => {
        return state.allAccountDetailsData;
    },
    recentChargesDataListGetters: state => {
        return state.rechargeChargedData;
    },
    paymentDataListGetters: state => {
        return state.paymentChargedData;
    },
    paymentDateIndexListGetters: state => {
        return state.paymentIndexData;
    },
}
export default {
    state,
    mutations,
    actions,
    getters
}